import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const companyInformationSlice = createSlice({
  name: "pendingCompanyInformation",
  initialState: false,
  reducers: {
    setFieldCompleted: (state, action: PayloadAction<boolean>) => {
     return action.payload
    },
    
  },
});

export const { setFieldCompleted } = companyInformationSlice.actions;
export default companyInformationSlice.reducer;
